import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  upsTermsLabel: {
    description: 'UPS terms acceptance checkbox label with links to terms documents',
    defaultMessage:
      'I agree that my shipping activity will be governed by the following terms: {supplemental}, {technology}, and {prohibited}.',
    id: 'preEye',
  },
  upsSupplementalTerms: {
    description: 'UPS Supplemental Terms and Conditions link text',
    defaultMessage: 'UPS Supplemental Terms and Conditions',
    id: '3mV+sA',
  },
  upsTechnologyAgreement: {
    description: 'UPS technology agreement link text',
    defaultMessage: 'UPS Technology Agreement',
    id: 'klo/gr',
  },
  upsProhibitedItems: {
    description: 'UPS list of prohibited items link text',
    defaultMessage: 'List of Prohibited Items',
    id: 'aXYnqZ',
  },
});
